import { ChevronRightIcon } from '@heroicons/react/20/solid'

import { Link } from '@remix-run/react'
import { classNames } from '~/utils/client/helpers'

export type LinkBoxProps = {
  title: string
  icon?: any
  children?: React.ReactNode
  to: string
  className?: string
}

export const LinkBox = ({ title, icon: TitleIcon, children, to, className }: LinkBoxProps) => {
  return (
    <Link
      to={to}
      className={classNames(
        'flex focus-ring-brand-inset-stack h-full overflow-hidden pointer bg-white justify-between group/link hover:bg-surface-inset',
        className
      )}
    >
      <div className={'flex flex-col justify-center'}>
        <div className="flex items-center gap-6">
          {TitleIcon && <TitleIcon className="w-8 text-brand-hover" />}
          <span className="text-base text-secondary">{title}</span>
          {children && children}
        </div>
      </div>
      <div className="bg-white px-4 flex items-center group-hover/link:bg-surface-inset">
        <ChevronRightIcon className="w-6" />
      </div>
    </Link>
  )
}
